export enum DataMigrationErrorTypes {
	Success = -1,
	Error = 0,
	InvalidFormat = 1,
	InvalidFormatEmail = 2,
	InvalidFormatPhone = 3,
	InvalidFormatDate = 4,
	InvalidFormatNumber = 5,
	MappedEntityNotFound = 6,
	Required = 7,
	DuplicateMappings = 8,
}

export interface RowWithSelectedCells {
	row: any;
	values: any[];
}

export interface DataMigrationError {
	worksheet: string;
	rangeStart: string;
	rangeEnd: string;
	errorType: DataMigrationErrorTypes;
	errorMessage: string;
	errorMessageParams: any[];
	validatedBlock: RowWithSelectedCells[];
}
